const VoucherCodeErrorTypes = Object.freeze({
  SYSTEM_ERROR: 'SYSTEM_ERROR',
  EXPIRED_CODE: 'EXPIRED_CODE',
  NON_EXISTENT_CODE: 'NON_EXISTENT_CODE',
  REDEEMED_CODE: 'REDEEMED_CODE',
});
export { VoucherCodeErrorTypes };
